module.exports = __webpack_public_path__ + "img/video-flesh.05a43b0d.jpg";